<div class="row">
  <div class="content">
    {{ merchant.company }}
  </div>
  <div class="caption">
    <small>
      {{ "account.merchant.name" | translate }}
    </small>
  </div>
</div>
<div class="row">
  <div class="content">
    <span>
      {{ merchant.merchantId }}
    </span>
  </div>
  <div class="caption">
    <small>
      {{ "account.merchant.id" | translate }}
    </small>
  </div>
</div>
<div class="row">
  <div class="content">
    <span>
      {{ merchant.email }}
    </span>
  </div>
  <div class="caption">
    <small>
      {{ "account.merchant.email" | translate }}
    </small>
  </div>
</div>
<div class="row pos">
  <div class="caption">
    <small>
      {{ "account.merchant.pos" | translate }}
    </small>
  </div>

  <ul class="pos-list">
    <li *ngFor="let pos of merchant.pointOfSales">
      {{ pos.name }} ({{ pos.id }})
    </li>
  </ul>
</div>
